import { ALLOCATE_POSITIONS } from 'constants/endpoints';
import { METHOD_POST } from 'requests';
import { ApiRequestConfigType } from 'requests/index.types';

interface CommunitiesPositionsAttribute {
  id?: number;
  position_id?: number;
  supervisor: boolean;
}

interface UpdatePositionsAllocationPayload {
  community: {
    communities_positions_attributes: CommunitiesPositionsAttribute[];
  };
}

export const API_POST_updateCustomerPositionsAllocation = (
  id: string,
  payload: UpdatePositionsAllocationPayload,
): ApiRequestConfigType => {
  return {
    method: METHOD_POST,
    url: ALLOCATE_POSITIONS(id),
    __typename: 'LegacyAPI',
    body: payload,
  };
};
